import {
    faCircleCheck,
} from '@fortawesome/free-solid-svg-icons';
import React, { useCallback, useEffect, useState } from 'react';
import styles from './index.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TableSkeleton from '../../../components/Skeleton';
import NoResultsFound from '../../../components/NoResultsFound';
import Modal from '../../../components/Modal';
import { showToast } from '../../../components/ToastMsg';
import Pagination from '../../../components/Pagination';
import { getWinnersList, publishWinnerInfo } from '../../../redux/features/winners/winnersService';
import { getInquiriesList } from '../../../redux/features/inquiries/inquiriesService';

const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const Inquiries = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isInquiriesLoading, pageCount, inquiries } = useSelector((state) => state.inquiry.inquiriesList);

    const [isDeactivationModalOpen, setDeactivationModalOpen] = useState(false);
    const [selectedInquiryId, setSelectedInquiryId] = useState(null);
    const [selectedInquiryName, setSelectedInquiryName] = useState('');
    const [reload, setReload] = useState(false);
    const [drawDate, setDrawDate] = useState(formatDate(new Date()));
    const [skip, setSkip] = useState(1);
    const limit = 25;

    const closeDeactivationModal = () => setDeactivationModalOpen(false);

    const fetchAllInquiries = useCallback(
        (filters = {}) => {
            const params = {
                skip: skip,
                limit: limit,
                ...filters,
            };
            dispatch(getInquiriesList(params));
        },
        [dispatch, skip]
    );

    useEffect(() => {
        fetchAllInquiries();
    }, [fetchAllInquiries]);


    const viewInquiry = (id) => {
        navigate(`/viewer/inquiries/${id}`)
    }
    const handlePageChange = (pageNumber) => {
        setSkip(pageNumber);
    };

    return (
        <div className={`search-card`}>
            <div className={`search-card-header`}>
                <div className={`form-input-col`}>
                    <h1 className={`form-title ${styles.headDiv}`}>
                        Inquiry Listing{' '}
                    </h1>
                </div>
                <div className={`form-input-col`}>
                </div>
            </div>

            <div>
                {isInquiriesLoading ? (
                    <TableSkeleton
                        columns={['Name', 'Email', 'Subject', 'Status', 'Actions']}
                        rowCount={10}
                        height={20}
                    />
                ) : inquiries.length > 0 ? (
                    <div className={`table-container`}>
                        <table className={`table`}>
                            <thead className={`thead`}>
                                <tr>
                                    <th className={`theadColumnOne`}>Name</th>
                                    <th>Email</th>
                                    <th>Subject</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody className={`tbody`}>
                                {inquiries?.map((inquiry) => (
                                    <tr key={inquiry.id}>
                                        <td className={`tdataColumnOne`}>{inquiry?.name}</td>
                                        <td>{inquiry?.email}</td>
                                        <td>{inquiry?.subject}</td>
                                        <td className={styles.smTd}>
                                            <p className={`status-text-label ${inquiry?.status?.toLowerCase()}`}>{inquiry?.status}</p>
                                        </td>
                                        <td className={`actionsBtn`}>
                                            <button className={`btn-primary`} onClick={() => {
                                                viewInquiry(inquiry.id);
                                            }}>
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <NoResultsFound />
                )}
                <div className={`search-card-footer`} style={{ marginTop: '20px' }}>
                    {pageCount > 0 && (
                        <div className={styles.paginationContainer}>
                            <Pagination
                                currentPage={skip}
                                totalPages={pageCount}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Inquiries;
